import { createContext } from 'react';

const WebsocketContext = createContext({
  eventsWs: null
});

export default WebsocketContext;
